import { render, staticRenderFns } from "./StatisticsItemCard.vue?vue&type=template&id=3fea24b5&scoped=true&"
import script from "./StatisticsItemCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea24b5",
  null
  
)

export default component.exports